import React from "react";
import WalletCard from "./wallet_card/WalletCard";
import RankCard from "./rank_card/RankCard";
import "./WalletRank.css";
import TotalBalance from "./total_balance/TotalBalance";
export default function WalletRank() {
  return (
    <section className="wallet-rank-section">
      <div className="container">
        <div className="row px-lg-5 g-3 align-items-stretch tab-view">
          {/* <div className="col-lg-4 wallet">
            <h4>Current Balance</h4>
            <WalletCard />
          </div> */}

          <div className="col-lg-4 rank">
            <h4>Rewards</h4>
            {/* <h4>Your Customer</h4> */}
            <RankCard />
          </div>

          {/* <div className="col-lg-4 wallet">
            <h4>Total Earnings</h4>
            <TotalBalance />
          </div> */}
        </div>
      </div>
    </section>
  );
}
